import * as React from 'react';
import Fallback from './components/fallback.jsx';
import BasicTable from './components/details_table.jsx';
import PriceFilter from './components/PriceFilter.jsx';
import BookingConfirmation from './components/BookingConfirmation.jsx';
//import BasicChips from './components/card.jsx';

export default function ComponentSelector({ messageData }) {


  if (messageData.attachment.type === "details_table") {

    return (<div id="Table"><BasicTable
      address={messageData.attachment.address}
      floor={messageData.attachment.floor}
      rent={messageData.attachment.rent}
      deposit={messageData.attachment.deposit}
      size={messageData.attachment.size}
      images={messageData.attachment.images}
      numBedrooms={messageData.attachment.bedrooms} 
      lang_id={messageData.attachment.lang_id}/>

      </div>);

  }


  else if (messageData.attachment.type === "price_filter_component") {

    return (<div id="Filter"><PriceFilter
      min_price={messageData.attachment.min_rent}
      max_price={messageData.attachment.max_rent}
      lang_id={messageData.attachment.lang_id}/>

      </div>);

  }

  if (messageData.attachment.type === "booking_confirmation") {

    return (<div id="booking_confirmation"><BookingConfirmation
      address={messageData.attachment.address}
      floor={messageData.attachment.floor}
      rent={messageData.attachment.rent}
      deposit={messageData.attachment.deposit}
      size={messageData.attachment.size}
      images={messageData.attachment.images}
      numBedrooms={messageData.attachment.bedrooms}
      name={messageData.attachment.name}
      email={messageData.attachment.email}
      telephone_number={messageData.attachment.telephone_number}
      message={messageData.attachment.message}
      apartment_id={messageData.attachment.apartment_id} 
      lang_id={messageData.attachment.lang_id}/>

      </div>);

  }

  /*else if(messageData[0].type==="basic_chip"){ 

  return <BasicChips messageData={messageData[0].text} />;


  }*/
  else return <Fallback />;

}




